import apiUrl from "../../../constants";
import axios from "axios";
import Paginate from "vuejs-paginate";
import Pagination from "./../shared/pagination";
import { Validator } from "vee-validate";
import VueElementLoading from "vue-element-loading";
export default {
  name: "client",
  components: {
    Paginate,
    Pagination,
    VueElementLoading,
  },
  data: function () {
    return {
      gstcheck: 0,
      pancheck: 0,
      totalPage: 0,
      totalRows: 0,
      currentPage: 1,
      pageLimit: 10,
      // currentPage: 0,
      //modalShow used for close the active/inactive modal(default)
      modalShow: false,
      editclientmodal: false,
      addclientmodal: false,
      addmodalshow: false,
      status: "",
      clientaction: "",
      listClientData: [],
      listStateData: [],
      listCityData: [],
      listRoleData: [],
      // pageno: 0,
      // totalPage: 0,
      clientname: "",
      clientpersonemail: "",
      clientpersonmobile: "",
      clientaddress: "",
      clientid: "",
      city_name: "",
      terms: false,
      id: "",
      isLoading: false,
      is_Loading: false,
      resultCount: "",
      model: {
        clientname: "",
        clientpersonemail: "",
        clientaddress: "",
        clientaddress2: "",
        country: "",
        state: "",
        city: "",
        clientpincode: "",
        clientpersonname: "",
        clientpersonmobile: "",
        clientpersonphone: "",
        clientregisternum: "",
        clientpanid: "",
        clientgstnum: "",
        clientloginemail: "",
        status: "",
        password: "",
      },
      // initialize form field
      addclient: {
        clientname: "",
        clientpersonemail: "",
        clientaddress: "",
        clientaddress2: "",
        country: "",
        state: "",
        clienttype: "",
        city: "",
        clientpincode: "",
        clientpersonname: "",
        clientpersonmobile: "",
        clientpersonphone: "",
        clientregisternum: "",
        clientpanid: "",
        clientgstnum: "",
        clientloginemail: "",
        status: "",
        password: "",
        pool:100,
        clietnDBName:"",
        clientcodename:""

      },
      checked_roleid: [],
      status: "",
      changestatus: "",
    };
  },
  created: function () {},
  // when a page loads,mounted() will be call
  mounted() {
    this.pageno = 0;
    this.getClientData();
    this.getStateList();
    this.getRoleList();
  },
  methods: {
    validatePan() {
      var txtPANCard = document.getElementById("clientpanNumber");
      var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
      if (regex.test(txtPANCard.value.toUpperCase())) {
        this.pancheck = 0;
      } else {
        this.pancheck = 1;
        return false;
      }
    },
    //validate gst
    validateGst() {
      var txtgst = document.getElementById("clientgstnum");
      var regexx =
        /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/;
      if (regexx.test(txtgst.value.toUpperCase())) {
        this.gstcheck = 0;
      } else {
        this.gstcheck = 1;
        return false;
      }
    },

    validateformat() {
      var txtPANCard = document.getElementById("clientpanNumber");
      var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
      if (regex.test(txtPANCard.value.toUpperCase())) {
        this.pancheck = 0;
        console.log("=======log==");
        var txtgst = document.getElementById("clientgstnum");
        var regexx =
          /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/;
        if (regexx.test(txtgst.value.toUpperCase())) {
          this.gstcheck = 0;
          if (this.clientaction == "add") {
            this.saveClient();
          } else if (this.clientaction == "edit") {
            this.editClient();
          }
        } else {
          console.log("Invalid GST No");
          this.gstcheck = 1;
          return false;
        }
      } else {
        this.pancheck = 1;
        console.log("Invalid Pan No");
        return false;
      }
    },

    //open new form(popup)
    addNewClient() {
      (this.addclient.clientstate = ""),
        (this.addclient.clientcity = ""),
        (this.gstcheck = 0),
        (this.pancheck = 0),
        (this.addclient.clientname = "");
      this.addclient.clientpersonemail = "";
      this.addclient.clientaddress = "";
      this.addclient.clientaddress2 = "";
      this.addclient.country = "";
      this.addclient.state = "";
      this.addclient.city = "";
      this.addclient.clienttype = "";
      this.addclient.clientpincode = "";
      this.addclient.clientpersonname = "";
      this.addclient.clientpersonmobile = "";
      this.addclient.clientpersonphone = "";
      this.addclient.clientregistern = "";
      this.addclient.clientpanid = "";
      this.addclient.clientgstnum = "";
      this.addclient.clientloginema = "";
      this.addclient.status = "";
      this.addclient.password = "";
      document.getElementById("clientname").value = "";
      document.getElementById("clientpersonname").value = "";
      document.getElementById("clientpersonemail").value = "";
      document.getElementById("clientaddress").value = "";
      document.getElementById("clientaddress2").value = "";
      document.getElementById("clientcountry").value = "";
      document.getElementById("state").value = "";
      document.getElementById("city").value = "";
      document.getElementById("clienttype").value = "";
      document.getElementById("pincode").value = "";
      document.getElementById("mobile").value = "";
      document.getElementById("clientpersonphone").value = "";
      document.getElementById("clientregisternum").value = "";
      document.getElementById("clientpanNumber").value = "";
      document.getElementById("clientgstnum").value = "";
      document.getElementById("clienttype").disabled=false;
      //	document.getElementById("password").value = ''
      //to initialize all form field or used for clear the form
      // this.addclient = [],
      this.clientaction = "add";
      this.addclientmodal = true;
      this.getCityList()

      //to clear error messages(validation messages)
      this.$validator.reset();
      this.errors.clear();
    },
    addmodalShow() {
      this.Statusaction = "add";
      this.addmodalShow = true;
    },
    //to close active/inactive modal
    closeaddmodalShow() {
      this.addmodalShow = false;
    },
    //to close new form
    closeAddClientModal() {
      this.addclientmodal = false;
    },
    //to close edit form
    closeEditClientModal() {
      this.addclientmodal = false;
    },
    //to reset search form
    resetForm() {
      this.clientpersonemail = "";
      this.addclient.clienttype = "";
      this.clientname = "";
      this.clientpersonmobile = "";
      this.getClientData();
    },
    //for active/inactive modal
    changeClientStatus() {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");

      axios({
        method: "POST",
        url: apiUrl.api_url + "updateClientStatus",
        data: {
          clientid: this.clientid,
          status: this.status.trim(),
        },
        headers: {
          Authorization: "Bearer " + myStr,
        },
      })
        .then((response) => {
          if (response.data.msg > 0) {
            this.$alertify.success("Client Status update Successfully");
            this.addclientmodal = false;
            this.getClientData();
          }
        })
        .catch((httpException) => {
          console.error("exception is:::::::::", httpException);
        });
    },
    //to get state list
    getStateList() {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");
      this.input = {};
      axios({
        method: "POST",
        url: apiUrl.api_url + "stateList",
        data: this.input,
        headers: {
          Authorization: "Bearer " + myStr,
        },
      }).then(
        (result) => {
          this.listStateData = result.data;
        },
        (error) => {
          console.error(error);
        }
      );
    },
    //depending on state ,get city list
    getCityList() {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");
      this.input = {
        statename: this.addclient.clientstate,
      };
      axios({
        method: "POST",
        url: apiUrl.api_url + "cityList",
        data: this.input,
        headers: {
          Authorization: "Bearer " + myStr,
        },
      }).then(
        (result) => {
          this.listCityData = result.data;
        },
        (error) => {
          console.error(error);
        }
      );
    },
    getClientSerach() {
      this.totalPage = 0;
      this.currentPage = 1;
      this.resultCount = 0;
      this.searchFlag = true;
      this.getClientData();
    },
    //to get client list
    getClientData() {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");

      this.input = {
        offset: (this.currentPage - 1) * 10,
        limit: 10,
        clientname: this.clientname.trim(),
        clientpersonemail: this.clientpersonemail.trim(),
        clientpersonmobile: this.clientpersonmobile.trim(),
      };
      this.isLoading = true;
      axios({
        method: "POST",
        url: apiUrl.api_url + "clientMaster",
        data: this.input,
        headers: {
          Authorization: "Bearer " + myStr,
        },
      }).then(
        (result) => {
          this.listClientData = result.data.rows;
          this.isLoading = false;
          this.totalRows = result.data.count;
          this.resultCount = result.data.count;
          if (this.totalRows < 10) {
            this.totalPage = 1;
          } else {
            this.totalPage = Math.ceil(this.totalRows / 10);
          }
        },
        (error) => {
          console.error(error);
        }
      );
    },
    // save form fields in mysql database
    saveClient() {
      //console.log(this.addclient.clientname);
      //	this.is_Loading = true
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");
      axios({
        method: "POST",
        url: apiUrl.api_url + "SubmitClientData",
        data: {
          clientname: this.addclient.clientname,
          clientpersonname: this.addclient.clientpersonname,
          password: this.addclient.clientname,
          clientaddress: this.addclient.clientaddress,
          clientaddress2: this.addclient.clientaddress2,
          city: this.addclient.clientcity,
          clienttype: this.addclient.clienttype,
          state: this.addclient.clientstate,
          country: this.addclient.clientcountry,
          clientpanid: this.addclient.clientpanid,
          clientgstnum: this.addclient.clientgstnum,
          clientregisternum: this.addclient.clientregisternum,
          clientpersonemail: this.addclient.clientpersonemail,
          clientpersonphone: this.addclient.clientpersonphone,
          clientpersonmobile: this.addclient.clientpersonmobile,
          pincode: this.addclient.clientpincode,
          clientloginemail: this.addclient.clientloginemail,
          password: this.addclient.password,
          clietnDBName: this.addclient.clietnDBName,
          clientcodename: this.addclient.clientcodename,
          pool: this.addclient.pool,
        },
        headers: {
          Authorization: "Bearer " + myStr,
        },
      })
        .then((response) => {
          if (response.data.msg == 1) {
            this.is_Loading = false;
            this.$alertify.success("Client Created Successfully");
            this.addclientmodal = false;
            this.getClientData();
          } else if (response.data.msg == 2) {
            this.is_Loading = false;
            this.$alertify.error("Client already existed");
          }
        })
        .catch((httpException) => {
          console.error("exception is:::::::::", httpException);
        });
    },
    //to get target id in edit action
    async getClientRowData(data) {
      this.clientaction = "edit";
      this.addclientmodal = true;
      this.$validator.reset();
      this.errors.clear();
      this.addclient = data;
      this.resultCount = 0;
      this.clientid = data.clientid;
      this.addclient.clientname = data.clientname;
      this.addclient.clientpersonname = data.clientpersonname;
      this.addclient.clientpersonemail = data.clientpersonemail;
      this.addclient.clientaddress2 = data.clientaddress2;
      this.addclient.clientaddress = data.clientaddress;
      this.addclient.clientpersonmobile = data.clientpersonmobile;
      this.addclient.clientpersonphone = data.clientpersonphone;
      this.addclient.clientregisternum = data.clientregisternum;
      this.addclient.clientpanid = data.clientpanid;
      this.addclient.clientgstnum = data.clientgstnum;
      this.addclient.clientstate = data.state;
      let result = await Promise.all([this.getCityList()]);
      this.addclient.clientcity = data.city;
      this.addclient.clienttype = data.clienttype;
      this.addclient.clientcountry = data.country;
      this.addclient.clientpincode = data.pincode;
      this.addclient.clietnDBName = data.clietnDBName;
      this.addclient.clientcodename = data.clientcodename;
      this.addclient.pool = data.pool;

      document.getElementById("clientname").value = data.clientname;
      document.getElementById("clientpersonname").value = data.clientpersonname;
      document.getElementById("clientpersonemail").value = data.clientpersonemail;
      document.getElementById("clientaddress").value = data.clientaddress;
      document.getElementById("clientaddress2").value = data.clientaddress2;
      document.getElementById("clientcountry").value = data.country;
      document.getElementById("state").value = data.state;
      document.getElementById("city").value = data.city;
      document.getElementById("clienttype").value = data.clienttype;
      document.getElementById("pincode").value = data.pincode;
      document.getElementById("mobile").value = data.clientpersonmobile;
      document.getElementById("clientpersonphone").value = data.clientpersonphone;
      document.getElementById("clientregisternum").value = data.clientregisternum;
      document.getElementById("clientpanNumber").value = data.clientpanid;
      document.getElementById("clientgstnum").value = data.clientgstnum;

      document.getElementById("clienttype").disabled=true;

    },
    
    //update form fields
    editClient() {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");

      this.input = {
        clientid: this.clientid,
        clientname: this.addclient.clientname,
        clientpersonname: this.addclient.clientpersonname,
        clientaddress: this.addclient.clientaddress,
        clientaddress2: this.addclient.clientaddress2
          ? this.addclient.clientaddress2
          : "",
        city: this.addclient.clientcity,
        state: this.addclient.clientstate,
        country: this.addclient.clientcountry,
        clientpanid: this.addclient.clientpanid,
        clientgstnum: this.addclient.clientgstnum,
        clientregisternum: this.addclient.clientregisternum,
        clientpersonemail: this.addclient.clientpersonemail,
        clientpersonphone: this.addclient.clientpersonphone,
        clientpersonmobile: this.addclient.clientpersonmobile,
        pincode: this.addclient.clientpincode,
        
        
      };
      this.is_Loading = true;
      axios({
        method: "POST",
        url: apiUrl.api_url + "updateClient",
        data: this.input,
        headers: {
          Authorization: "Bearer " + myStr,
        },
      })
        .then((response) => {
          if (response.data.status == true){
            this.is_Loading = false;
            this.$alertify.success("Client Record saved Successfully");
            this.addclientmodal = false;
            this.getClientSerach();
          }
        })
        .catch((httpException) => {
          console.error("exception is:::::::::", httpException);
        });
    },
    //to get target id in active/inactive modal
    getStatusRowData(data) {
      this.Statusaction = "add";
      this.modalShow = true;
      this.clientid = data.clientid;
      this.status = data.cstatus;
      if (data.cstatus.trim() == "active") {
        this.changestatus = "De-Activate";
      } else {
        this.changestatus = "Activate";
      }
    },
    closeStatusClientModal() {
      this.modalShow = false;
    },
    //to get pagination
    // getPaginationData(currentPage) {
    //   this.pageno = (currentPage - 1) * 10
    //   this.getClientData()
    // },
    onPageChange(page) {
      this.currentPage = page;
      this.getClientData();
    },
    //validate all form fields on onsubmit()
    onSubmit() {
      this.$validator
        .validateAll()
        .then((result) => {
          //console.log("=====486-------");
          if (!result) {
            //console.log("form is invalid", this.model);
            //console.log("=====488-----------");
            return false;
          } else {
            console.log("form is valid", this.model);
            this.validateformat();
          }
        })
        .catch(() => {
          console.log("errors exist", this.errors);
        });
    },
    // Get the role List
    getRoleList() {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");

      this.input = {};
      axios({
        method: "POST",
        url: apiUrl.api_url + "getRoleidname",
        data: this.input,
        headers: {
          Authorization: "Bearer " + myStr,
        },
      }).then(
        (result) => {
          this.listRoleData = result.data;
        },
        (error) => {
          console.error(error);
        }
      );
    }, // End Of get Role List
  },
};



// WEBPACK FOOTER //
// ./src/views/components/client/client.component.js